import React, { useEffect } from 'react';
import { useAuthnMe } from './AuthnMeProvider';
import {
  configurePreferencesAuthHeaders,
  usePreferencesStore,
} from './preferences';

export function PreferencesGate({
  children,
}: {
  children: React.ReactNode;
}) {
  const authnMe = useAuthnMe();
  const loadPreferences = usePreferencesStore((state) => state.loadPreferences);
  // Store action (not a hook) — named so eslint's rules-of-hooks doesn't
  // mistake the call inside the effect below for a hook call.
  const switchToLocalPreferences = usePreferencesStore((state) => state.useLocalPreferences);

  useEffect(() => {
    configurePreferencesAuthHeaders(authnMe.getAuthHeaders);
  }, [authnMe.getAuthHeaders]);

  useEffect(() => {
    if (authnMe.isLoading) return;
    // Server-side preferences are keyed by AuthnMe user id (user_preferences.go
    // is JWT-only), so an API-key session keeps its preferences in the browser.
    if (!authnMe.isConfigured || !authnMe.isAuthenticated || authnMe.authMethod === 'api_key') {
      switchToLocalPreferences();
      return;
    }
    const nextUserKey = authnMe.user?.userId || authnMe.token || 'authenticated';
    void loadPreferences(nextUserKey, authnMe.getAuthHeaders());
  }, [
    authnMe.authMethod,
    authnMe.getAuthHeaders,
    authnMe.isAuthenticated,
    authnMe.isConfigured,
    authnMe.isLoading,
    authnMe.token,
    authnMe.user?.userId,
    loadPreferences,
    switchToLocalPreferences,
  ]);

  return <>{children}</>;
}

export default PreferencesGate;
